import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { Button } from 'react-bootstrap';

import { getInvoices, downloadInvoice } from '../BillingActions';

// Import Style
import '../Billing.scss';

// Import Style

class Invoices extends Component {
  static defaultProps = {
    invoices: [],
  };

  constructor(props) {
    super(props);

    this.handleLoadMore = this.handleLoadMore.bind(this);
    this.handleDownload = this.handleDownload.bind(this);
  }

  handleLoadMore(next) {
    this.props.getInvoices(next);
  }

  handleDownload(id) {
    this.props.downloadInvoice(id);
  }

  render() {
    const { invoices } = this.props;

    if (!invoices.list || !invoices.list.length) {
      return (
        <div className='white_box_details'>
          <span>No invoices</span>
        </div>
      );
    }

    return (
      <div className='white_box_details'>
        <h3>Invoices</h3>
        <p>List of all invoices</p>
        <table className='table_invoices'>
          <tbody>
            {invoices.list.map((i, index) => {
              return (
                <tr key={index}>
                  <td>{moment.unix(i.invoice.date).format('DD MMM YYYY')}</td>
                  <td>${(i.invoice.total / 100).toFixed(2)}</td>
                  <td>
                    <span className={`status ${i.invoice.status}`}>{i.invoice.status.replace('_', ' ')}</span>
                  </td>
                  <td>
                    <Button variant="link" onClick={() => this.handleDownload(i.invoice.id)}>View invoice</Button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        {invoices.next_offset && (
          <Button size="md" className='btn-ml-auto mt-4' onClick={() => this.handleLoadMore(invoices.next_offset)}>
            Show earlier invoices
          </Button>
        )}
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getInvoices: (offset) => dispatch(getInvoices(offset)),
    downloadInvoice: (id) => dispatch(downloadInvoice(id)),
  };
};

export default connect(undefined, mapDispatchToProps)(Invoices);
